<template>
  <b-card no-body header="光化学污染分析" class="mt-4" style="font-size:1rem;">
    <b-list-group flush>
      <b-list-group-item :active="name=='concentration'" to="concentration">
        <!-- <i class="fa fa-area-chart" aria-hidden="true"></i> -->
        VOC浓度组分和物种浓度分析
      </b-list-group-item>
      <b-list-group-item>VOC活性分析</b-list-group-item>
      <b-list-group-item>VOC最大臭氧生成能力分析</b-list-group-item>
      <b-list-group-item href="#">VOC时间序列分析</b-list-group-item>
      <b-list-group-item href="#">VOC源分析</b-list-group-item>
      <b-list-group-item href="#">VOC物种相关性分析</b-list-group-item>
      <b-list-group-item href="#">臭氧敏感性分析</b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
export default {
  name: "PmLeftMenu",
  props: {
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>

